import { styled, Box, Stack } from '@mui/material'

export const StyledMain = styled(Box)(({ theme }) => {
  const isLight = theme.palette.mode === 'light'

  return {
    flex: '1',
    overflow: 'auto',
    backgroundImage: isLight
      ? 'radial-gradient(circle at 20% 30%, rgba(255,50,50,.1), transparent 45%), radial-gradient(circle at 70% 80%, rgba(0,150,255,.13), transparent 50%), radial-gradient(circle at 80% 10%, rgba(0,150,255,.05), transparent 30%)'
      : 'radial-gradient(circle at 20% 30%, rgba(255, 50, 50, 0.1), transparent 45%), radial-gradient(circle at 70% 80%, rgba(0, 150, 255, 0.13), transparent 50%), radial-gradient(circle at 80% 10%, rgba(0, 150, 255, 0.05), transparent 30%)',
    '&::-webkit-scrollbar-thumb': {
      backgroundColor:
        theme.palette.mode === 'light'
          ? theme.palette.grey[400]
          : theme.palette.grey[700],
    },
    // backgroundImage: `radial-gradient(circle at 20% 30%, ${theme.palette.secondary.main}1A, transparent 45%), radial-gradient(circle at 70% 80%, ${theme.palette.primary.main}21, transparent 50%)`,
  }
})

export const StyledStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isMini',
})(({ theme, isMini }) => {
  const isLight = theme.palette.mode === 'light'

  return {
    backgroundImage: isLight
      ? 'radial-gradient(at 0% 40%, #F8E8EA 30px, #F9E5E7 45%, #D9CFEE 85%)'
      : 'radial-gradient(at 0% 40%, #3A2C3F 30px, #443247 45%, #1E1B2B 85%)',
    // backgroundImage: `radial-gradient(at 0% 40%, ${
    //   isLight ? theme.palette.secondary.light : '#3A2C3F'
    // } 30px, ${isLight ? theme.palette.primary.light : '#1E1B2B'} 85%)`,
    borderBottomLeftRadius: 80,
    minHeight: isMini ? 'auto' : 230,
    paddingTop: theme.spacing(5),
    paddingBottom: isMini ? theme.spacing(3) : theme.spacing(2),
  }
})

export const BackgroundAvatar = styled(Box)(({ theme }) => {
  const isLight = theme.palette.mode === 'light'

  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    width: theme.spacing(12.5),
    height: theme.spacing(12.5),
    // boxShadow: `0 3px 6px 0 ${isLight ? '#362e2e75' : '#00000040'}`,
    // backgroundImage: isLight
    //   ? 'linear-gradient(to bottom, #fc0b7b, #c2638c, #257896 62%, #104952)'
    //   : 'linear-gradient(to bottom, #a1055a, #8c4f6e, #1e5f73 62%, #083341)',
    boxShadow: theme.shadows[3],
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.secondary.main}, ${theme.palette.primary.dark})`,
    backdropFilter: 'blur(30px)',
    marginBottom: theme.spacing(1),
  }
})
